
import React from 'react';
import { LoadingState } from '@/components/ui/loading-state';

export const BlogLoadingState: React.FC = () => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <LoadingState title="Loading article" size="lg" />
    </div>
  );
};
